###
Each integration should have an entry in this object. Keys should be the integration types we get from the connection service

- route:                              The angular app route to use when creating a new connection

- useIntegrationDirective:            when truthy, the integrationDirective will be
                                      used to create/edit connections of this type.

- templateUrl:                        The $templateCache id of the partial we want to use for this integration.

- cssClass (optional):                if this exists we use it as the css class for the integration logo
                                      if this doesn't exist we use `type` as the css class

- uiFeatureFlag (optional):           Determines which feature flag needs to be set in order to display an integration in CBI

- hideDefaultHeader:                  when truthy, the header bar will be hidden in directive.connectionEditor.html, so that it can be defined by the individual integration directive


###
angular.module('rjmNg').constant('INTEGRATION_CONFIGS'
  mysql: # MySQL
    uiFeatureFlag: "MYSQL_UI"
    route: "mysql"

  postgres: # PostgreSQL
    uiFeatureFlag: "POSTGRES_UI"
    route: "postgres"

  redshift: # Redshift
    uiFeatureFlag: "REDSHIFT_UNLOAD"
    route: "redshift"

  mongo: # MongoDB
    uiFeatureFlag: "MONGO_UI"
    route: "mongo"

  mssql: # SQL Server
    uiFeatureFlag: "MSSQL_UI"
    route: "mssql"

  "ad-words":
    uiFeatureFlag: 'ADWORDS_UI_V2'
    route: "ad-words"
    connectionCSSClass: "ad-words"
    useIntegrationDirective: true
    hideDefaultHeader: true
    templateUrl: "connectionEditors/ad-words.html"

  deskdotcom: # Desk.com
    uiFeatureFlag: "DESK_UI"
    useIntegrationDirective: true
    route: "desk"
    templateUrl: "connectionEditors/desk.html"

  facebook: # Facebook
    uiFeatureFlag: 'FACEBOOK_UI'
    route: "facebook"
    useIntegrationDirective: true
    templateUrl: "connectionEditors/facebook.html"
    defaultProperties:
      magento_oauth: "1"

  googleAdwords: # Google AdWords
    uiFeatureFlag: 'ADWORDS_UI'
    route: "google-adwords"

  googleAnalytics: # Google Analytics
    uiFeatureFlag: 'GOOGLE_ANALYTICS_UI'
    route: "google-analytics"

  "google-analytics-reporting": # Google Analytics Reporting
    route: "google-analytics-reporting"
    templateUrl: "connectionEditors/googleAnalyticsReporting.html"
    uiFeatureFlag: 'ANALYTICS_REPORTING_UI'
    useIntegrationDirective: true
    hideDefaultHeader: true
    pricing_tier: "premium"
    defaultProperties:
      magento_oauth: "1"

  "google_analytics4_live": # Google Analytics4 Live
    route: "google-analytics4-live"
    uiFeatureFlag: 'GOOGLE_ANALYTICS4_LIVE'

  googleEcommerce: # Google Ecommerce
    uiFeatureFlag: 'ECOMMERCE_UI'
    route: "google-ecommerce"

  jira: # JIRA
    uiFeatureFlag: 'JIRA_UI'
    route: "jira"

  mailchimp: # MailChimp
    uiFeatureFlag: 'MAILCHIMP_UI'
    route: 'mailchimp'
    useIntegrationDirective: true
    templateUrl: "connectionEditors/mailchimp.html"
    defaultProperties:
      magento_oauth: "1"

  mandrill: # Mandrill
    uiFeatureFlag: 'MANDRILL_UI'
    route: "mandrill"

  marketo: # Marketo
    uiFeatureFlag: 'MARKETO_UI'
    route: "marketo"

  mixpanel: # Mixpanel
    uiFeatureFlag: 'MIXPANEL_UI'
    route: "mixpanel"
    useIntegrationDirective: true
    templateUrl: "connectionEditors/mixpanel.html"

  netsuite: # NetSuite
    useIntegrationDirective: true
    uiFeatureFlag: 'NETSUITE_UI'
    route: "netsuite"
    templateUrl: "connectionEditors/netsuite.html"

  pardot: # Pardot
    uiFeatureFlag: 'PARDOT_UI'
    useIntegrationDirective: true
    route: "pardot"
    templateUrl: "connectionEditors/pardot.html"

  quickbooks: # QuickBooks
    uiFeatureFlag: 'QUICKBOOKS_UI'
    route: "quickbooks"

  recurly: # Recurly
    uiFeatureFlag: 'RECURLY_UI'
    route: "recurly"

  salesforce: # Salesforce
    uiFeatureFlag: 'SALESFORCE_UI'
    useIntegrationDirective: true
    route: "salesforce"
    templateUrl: "connectionEditors/salesforce.html"

  segment_webhooks: # Segment
    uiFeatureFlag: 'SEGMENT_UI'
    route: "segment"

  shopify: # Shopify
    uiFeatureFlag: 'SHOPIFY_UI'
    route: "shopify"
    useIntegrationDirective: true
    templateUrl: "connectionEditors/shopify.html"
    defaultProperties:
      magento_oauth: "1"

  stripe: # Stripe
    route: "stripe"
    uiFeatureFlag: 'STRIPE_UI'
    useIntegrationDirective: true
    templateUrl: "connectionEditors/stripe.html"
    defaultProperties:
      magento_oauth: "1"

  trello: # Trello
    uiFeatureFlag: 'TRELLO_UI'
    useIntegrationDirective: true
    route: "trello"
    templateUrl: "connectionEditors/trello.html"
    defaultProperties:
      magento_oauth: "1"

  zendesk: # Zendesk
    uiFeatureFlag: 'ZENDESK_UI'
    useIntegrationDirective: true
    route: "zendesk"
    templateUrl: "connectionEditors/zendesk.html"

  zopim: # Zopim
    uiFeatureFlag: 'ZOPIM_UI'
    route: "zopim"
    useIntegrationDirective: true
    templateUrl: "connectionEditors/zopim.html"

  zuora: # Zuora
    uiFeatureFlag: 'ZUORA_UI'
    useIntegrationDirective: true
    route: 'zuora'
    templateUrl: "connectionEditors/zuora.html"

  square: # Square
    uiFeatureFlag: 'SQUARE_UI'
    route: 'square'
    useIntegrationDirective: true
    templateUrl: "connectionEditors/square.html"
    cssClass: 'squareup'
    defaultProperties:
      magento_oauth: "1"

  push_api: # Data Import API
    route: 'import'

  userpush: {} # Upload a File

  "adobe-analytics":
    uiFeatureFlag: 'ADOBE_ANALYTICS'
    route: "adobe-analytics"
    connectionCSSClass: "adobe-analytics"
    useIntegrationDirective: true
    hideDefaultHeader: true
    templateUrl: "connectionEditors/adobe-analytics.html"
)
